/* AI-page signal.
   Extracted verbatim from artifact.html <script id="app"> (run()).

   INVARIANT — this is token OVERLAP, never a join. Google does not attribute queries to
   AI surfaces, so this compares the query's meaningful tokens against the tokens of the
   site's top AI-feature pages and flags a row when at least 2 tokens overlap. All copy
   must describe it as a separate overlap signal, never as "queries from AI Overviews". */

const STOP2 = new Set("the a an of for and or best top how what with blog blogs guide products collections www com".split(" "));

export const tok = s => String(s).toLowerCase().replace(/https?:\/\/[^/]+/, "").split(/[^a-z\u0900-\u097F0-9]+/).filter(t => t.length > 2 && !STOP2.has(t));

/* Demo data uses the top 22 pages; an uploaded Pages.csv uses the top 30 (already sorted
   by impressions at parse time). */
export const AI_PAGE_LIMIT = { demo: 22, upload: 30 };

export function buildAiTokenSets(pages, source = "upload") {
  if (!pages || !pages.length) return null;
  const limit = AI_PAGE_LIMIT[source] || AI_PAGE_LIMIT.upload;
  return pages.slice(0, limit).map(p => {
    const page = typeof p === "string" ? p : p.page;
    return { page, set: new Set(tok(page)) };
  });
}

/* Writes `aiPage` and `aiMatch` in place on every row. `aiMatch` names the page whose
   wording overlaps, so the table can show it as an inferred match — it remains an overlap,
   never a Google query-to-page join. */
export function flagAiPages(rows, aiTokens) {
  for (const d of rows) {
    const qt = tok(d.q);
    const hit = aiTokens
      ? aiTokens.find(entry => entry.set.size >= 2 && qt.filter(t => entry.set.has(t)).length >= 2)
      : null;
    d.aiPage = !!hit;
    d.aiMatch = hit ? hit.page : null;
  }
  return !!aiTokens;
}
